import React, { useState, useEffect } from 'react';
import { quranVideos } from './Quran';
import DashboardHeader from '../../../components/DashboardHeader';
import DashboardFooter from '../../../components/DashboardFooter';
import './QuranPage.css';
import { doc, updateDoc } from 'firebase/firestore';
import { db } from '../../../auth/firebase';
import { useAuthStore } from '../../../auth/state';
import cacheManager from '../../../auth/cache_manager';

function QuranPage() {
  // # State to track which video is expanded
  const [expandedVideo, setExpandedVideo] = useState(null);
  const { user } = useAuthStore();
  const [isDarkMode, setIsDarkMode] = useState(false);

  // # Load theme preference from user data on initial render
  useEffect(() => {
    const loadThemePreference = async () => {
      if (user && user.uid) {
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData && userData.themes && userData.themes.gen_theme !== undefined) {
          setIsDarkMode(userData.themes.gen_theme === 'dark');
        }
      }
    };
    
    loadThemePreference();
  }, [user]);

  // # Handle theme toggle
  const handleThemeToggle = async () => {
    try {
      const newTheme = !isDarkMode;
      setIsDarkMode(newTheme);
      
      if (user && user.uid) {
        await updateDoc(doc(db, 'users', user.uid), {
          'themes.gen_theme': newTheme ? 'dark' : 'light'
        });
        
        const userData = cacheManager.get(`user_${user.uid}`);
        if (userData) {
          const updatedUserData = {
            ...userData,
            themes: {
              ...(userData.themes || {}),
              gen_theme: newTheme ? 'dark' : 'light'
            }
          };
          cacheManager.set(`user_${user.uid}`, updatedUserData);
        }
      }
    } catch (error) {
      console.error('Error updating theme preference:', error);
    }
  };

  // # Handle tile click to expand/collapse
  const handleTileClick = (videoId) => {
    setExpandedVideo(expandedVideo === videoId ? null : videoId);
  };

  return (
    <div className={`qrn_page-container ${isDarkMode ? 'qrn_dark-mode' : ''}`}>
      <DashboardHeader isDarkMode={isDarkMode} onThemeToggle={handleThemeToggle} />
      
      <main className="qrn_main-content">
        <div className="qrn_header">
          <h1>Qur'an Recitation</h1>
          <p>Take a spiritual break with these beautiful recitations</p>
        </div>

        <div className="qrn_video-grid">
          {quranVideos.map((video) => (
            <div 
              key={video.id}
              className={`qrn_video-tile ${expandedVideo === video.id ? 'expanded' : ''}`}
              onClick={() => handleTileClick(video.id)}
            >
              <div className="qrn_tile-content">
                <div className="qrn_thumbnail-container">
                  {expandedVideo === video.id ? (
                    <iframe
                      src={video.videoUrl}
                      title={video.title}
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                      allowFullScreen
                    />
                  ) : (
                    <img 
                      src={video.thumbnailUrl} 
                      alt={video.title}
                      className="qrn_thumbnail"
                    />
                  )}
                </div>
                <h3>{video.title}</h3>
                <p>{video.description}</p>
              </div>
            </div>
          ))}
        </div>
      </main>

      <DashboardFooter isDarkMode={isDarkMode} />
    </div>
  );
}

export default QuranPage; 